import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import Truncate from 'react-truncate'
import { Text, CardContainer, ScrollSpy, constants } from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import { useListingContext } from 'common/context/listing'
import cls from './styles.scss'

const cx = classnames.bind(cls)

const PropertyDescription = () => {
  const { listing } = useListingContext()

  const isSmartSale = blueprint.listing.utils.isSmartSale(listing)

  const propertyDescription =
    listing.listing_remarks?.special_notes ||
    listing.listing_remarks?.mls_comment

  if (!propertyDescription) return null

  return (
    <CardContainer
      borderColor={constants.ColorNames.Gray}
      borderRadius='extra-small'
      dropShadow='small'
      padding='extra-small'
    >
      <Text
        color='gray'
        data-elm-id='property_description-title'
        size='tiny'
        style={{ marginBottom: 10 }}
        weight='heavy'
      >
        {isSmartSale ? 'Property Description' : 'Special Notes'}
      </Text>
      <ScrollSpy selector='#property_details'>
        {({ scrollTo }: { scrollTo: () => void }) => (
          <Text
            color='gray'
            data-elm-id='property_description_value'
            size='tiny'
          >
            <Truncate
              lines={5}
              ellipsis={
                <span>
                  {'... '}
                  <a
                    className={cx('u-pointer-cursor')}
                    onClick={scrollTo}
                    data-elm-id='property_description_value_more_label'
                  >
                    read more ↓
                  </a>
                </span>
              }
            >
              {propertyDescription}
            </Truncate>
          </Text>
        )}
      </ScrollSpy>
    </CardContainer>
  )
}

export default PropertyDescription
